/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
import { SelfLearningContentTypeFromJSON, SelfLearningContentTypeToJSON, } from './SelfLearningContentType';
/**
 * Check if a given object implements the CreateSelfLearningUnitGroupRequest interface.
 */
export function instanceOfCreateSelfLearningUnitGroupRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "detailDescription" in value;
    isInstance = isInstance && "tagList" in value;
    isInstance = isInstance && "subTitle" in value;
    isInstance = isInstance && "backgroundImageResourceId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "contentType" in value;
    return isInstance;
}
export function CreateSelfLearningUnitGroupRequestFromJSON(json) {
    return CreateSelfLearningUnitGroupRequestFromJSONTyped(json, false);
}
export function CreateSelfLearningUnitGroupRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detailDescription': json['detailDescription'],
        'tagList': json['tagList'],
        'subTitle': json['subTitle'],
        'backgroundImageResourceId': json['backgroundImageResourceId'],
        'title': json['title'],
        'contentType': SelfLearningContentTypeFromJSON(json['contentType']),
        'groupFilterId': !exists(json, 'groupFilterId') ? undefined : json['groupFilterId'],
    };
}
export function CreateSelfLearningUnitGroupRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detailDescription': value.detailDescription,
        'tagList': value.tagList,
        'subTitle': value.subTitle,
        'backgroundImageResourceId': value.backgroundImageResourceId,
        'title': value.title,
        'contentType': SelfLearningContentTypeToJSON(value.contentType),
        'groupFilterId': value.groupFilterId,
    };
}
